import React from 'react'
import Header from '../components/Header'
import { Navigate, Outlet, useLocation } from 'react-router'
import { useAuth } from '../../services/AuthProvider';

function PrivateLayout() {
    const auth = useAuth();
    const location = useLocation();

    if (!auth.token) {
        return <Navigate to="/login" state={{ page: location.pathname }} />;
    }
    return (
        <div className='bg-light'>
            <Header />
            <div className='px-5'>
                <Outlet />
            </div>
        </div>
    )
}

export default PrivateLayout